<template>
    <div :class="b()">
        <div id="app-buying" class="container -bg-grey">
            <div class="text-header">Общая информация</div>
            <div class="row">
                <div class="col-sm-12 col-md-6">
                    <div class="white-card">
                        <div class="white-card__data-row">Номер закупки: <span class="pull-right">{{ buyingPresenter.id }}</span>
                        </div>
                        <div class="white-card__data-row">Размещено: <span
                                class="pull-right">{{ buyingPresenter.createDate }}</span></div>
                        <div class="white-card__data-row">Тип закупки: <span
                                class="pull-right">{{ buyingPresenter.typeName }}</span></div>
                        <div class="white-card__data-row">Общая категория:
                            <template v-for="prototypeGroup in prototypeGroups">
                                <span class="pull-right">{{ prototypeGroup }}</span><br>
                            </template>
                        </div>
                        <div class="white-card__data-row">Подкатегория:
                            <template v-for="prototypeSubGroup in prototypeSubGroups">
                                <span class="pull-right">{{ prototypeSubGroup }}</span><br>
                            </template>
                        </div>
                        <div class="white-card__data-row">Этап закупки: <span
                                class="pull-right">{{ buyingPresenter.statusName }}</span></div>
                    </div>
                </div>
                <div class="col-sm-12 col-md-6">
                    <div class="white-card dopInfoCard">
                        <div class="white-card__data-row -style-big">Всего товаров: <span
                                class="pull-right">{{ buyingPresenter.itemsCount }} ед.</span></div>
                        <div class="white-card__data-row -style-big">Общая цена: <span
                                class="pull-right">{{ getFormattedPrice(buyingPresenter.sum) }} <i class="fa fa-ruble"></i></span></div>
                        <div class="white-card__data-row -style-big">Дата и время подведения итогов: <span
                                class="pull-right">{{ buyingPresenter.offerDate }}</span></div>
                    </div>
                    <div v-if="false" class="export-tools -style-buying no-print">
                        <a href="javascript:window.print()" class="btn -style-dark scr-print"><i
                                class="fa fa-print"></i> Печать</a>
                        <a :href="excelLink"
                           class="btn -style-dark">
                            <i class="fa fa-file-excel-o"></i> Экспорт Excel
                        </a>
                        <a :href="emailLink"
                           class="btn -style-dark">
                            <i class="fa fa-envelope-o"></i> Отправить email
                        </a>
                    </div>
                </div>
            </div>
            <form id="seller-offer" action="" v-on:submit.prevent="makeOffer">
                <div class="row">
                    <div class="col-sm-12">
                        <div class="text-header">Информация об объекте закупки</div>
                        <div class="white-card">
                            <table class="table buying__items-table">
                                <thead>
                                <tr>
                                    <th>Наименование</th>
                                    <th>Кол-во</th>
                                    <th>Ед.изм.</th>
                                    <th>НМЦК</th>
                                    <th>Цена за ед., <i class="fa fa-ruble"></i></th>
                                    <th>Ваша цена за ед., <i class="fa fa-ruble"></i></th>
                                </tr>
                                </thead>
                                <tbody class="rowgroup">
                                <template v-for="item in buyingPresenter.goods">
                                    <tr :id="'itemRow' + item.prototypeId" class="buying__item-row">
                                        <td class="mobile-font">
                                            {{ item.prototypePossibleValue }}
                                            <div class="link dropdown-toggle" data-toggle="modal"
                                                 :data-target="'#windowParticipant' + item.prototypeId">
                                                Подробнее об участниках: <i class="fa fa-search"></i>
                                            </div>
                                        </td>
                                        <td class="mobile-font">{{ item.prototypeCount }}</td>
                                        <td class="mobile-font">{{ item.prototypeUnit }}</td>
                                        <td class="mobile-font">{{ getFormattedPrice(item.prototypeContractStartPrice)
                                            }}
                                        </td>
                                        <td class="mobile-font">{{ item.minOffer }}</td>
                                        <td class="mobile-font-md" style="font-size: 12px">
                                            <p v-if="!item.isMinimalOffer">
                                            Предложите цену <br>
                                            От <a class="from-seller"
                                                  :data-offer="item.minPrice"
                                                  @click="setQuickPrice(item.minPrice, item)">{{ getFormattedPrice(item.minPrice) }}</a>
                                            До <a class="before-seller"
                                                  :data-offer="item.startSellerOffer"
                                                  @click="setQuickPrice(item.startSellerOffer, item)">{{
                                            getFormattedPrice(item.startSellerOffer) }}</a>
                                            </p>
                                            <input class="buying__offer-input" type="number" step="0.01"
                                                   :min="item.minPrice"
                                                   :name="'offer' + item.prototypeId" v-model="item.minOffer"
                                                   :max="item.startSellerOffer"
                                                   :disabled="
                                                       !buyingPresenter.isTender ||
                                                       item.isMinimalOffer">
                                            <template v-if="item.isMinimalOffer">
                                                <br><span>Действующее предложение</span>
                                            </template>
                                        </td>
                                    </tr>
                                </template>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <template v-if="buyingPresenter.isTender">
                    <div class="row">
                        <div class="col-sm-12">
                            <div class="col-sm-12 col-md-8 col-md-offset-2 buying-list__btns no-print">
                                <button type="submit" class="btn -color-green -size-big">Отправить предложение</button>
                            </div>
                        </div>
                    </div>
                </template>
            </form>
            <template v-if="this.buyingPresenter.isDemoUser">
                <div class="row">
                    <div class="col-sm-12">
                        <div class="col-sm-12 col-md-8 col-md-offset-2">
                            <button @click="openRegister" class="btn -color-blue -size-big">Зарегистрироваться</button>
                        </div>
                    </div>
                </div>
            </template>
        </div>

        <template v-for="item in buyingPresenter.goods">
            <div class="modal fade bd-example-modal-lg windowParticipant" :id="'windowParticipant' + item.position.id"
                 tabindex="-1"
                 role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true">
                <div class="modal-dialog modal-lg">
                    <div class="modal-content">
                        <div class="modal-header">
                            <button type="button" class="close" data-dismiss="modal" aria-hidden="true">×</button>
                            <h4 class="modal-title">Список покупателей</h4>
                        </div>
                        <div class="modal-body">
                            <template v-if="!item.showPartners">
                                <table class="table buying__items-table">
                                    <thead>
                                    <tr>
                                        <th></th>
                                        <th>Город</th>
                                        <th>Количество</th>
                                    </tr>
                                    </thead>
                                    <tbody class="rowgroup">
                                    <tr v-for="(distribution, idx) in item.distributions" class="buying__item-row">
                                        <td class="mobile-font">Покупатель {{ idx + 1 }}</td>
                                        <td class="mobile-font">{{ distribution.user.regionCity.title }}</td>
                                        <td class="mobile-font">{{ distribution.qty }} ед.</td>
                                    </tr>
                                    </tbody>
                                </table>
                            </template>

                            <template v-if="item.showPartners">
                                <table class="table buying__items-table">
                                    <thead>
                                    <tr>
                                        <th>Название</th>
                                        <th style="width: 45%;">Адрес доставки</th>
                                        <th>Количество</th>
                                        <th>Карта партнера</th>
                                    </tr>
                                    </thead>
                                    <tbody class="rowgroup">
                                    <tr v-for="distribution in item.distributions" class="buying__item-row">
                                        <td class="mobile-font">{{ distribution.user.corp_name }}</td>
                                        <td class="mobile-font">{{ distribution.user.official_seat }}</td>
                                        <td class="mobile-font">{{ distribution.qty }} ед.</td>
                                        <td class="mobile-font">
                                            <p v-if="distribution.user.director_full_name">
                                                <b>Директор:</b><br>
                                                {{ distribution.user.director_full_name }}
                                            </p>
                                            <p v-if="distribution.user.tax_ref_num">
                                                <b>ИНН:</b><br>
                                                {{ distribution.user.tax_ref_num }}
                                            </p>
                                            <p v-if="distribution.user.tax_reason_code">
                                                <b>КПП:</b><br>
                                                {{ distribution.user.tax_reason_code }}
                                            </p>
                                            <p v-if="distribution.user.psrn">
                                                <b>ОГРН/ОГРНИП:</b><br>
                                                {{ distribution.user.psrn }}
                                            </p>
                                            <p v-if="distribution.user.rcbic">
                                                <b>БИК:</b><br>
                                                {{ distribution.user.rcbic }}
                                            </p>
                                            <p v-if="distribution.user.bank_name">
                                                <b>Наименование банка:</b><br>
                                                {{ distribution.user.bank_name }}
                                            </p>
                                            <p v-if="distribution.user.transaction_account">
                                                <b>Расчетный счет:</b><br>
                                                {{ distribution.user.transaction_account }}
                                            </p>
                                            <p v-if="distribution.user.correspondent_account">
                                                <b>Корр. счет:</b><br>
                                                {{ distribution.user.correspondent_account }}
                                            </p>
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                            </template>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-secondary" data-dismiss="modal">Закрыть</button>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
    import BuyingService from "../services/BuyingService";

    const COMPONENT_NAME = 'seller-buying';

    export default {
        name: COMPONENT_NAME,
        props: ['id', 'type'],
        data() {
            return {
                buyingPresenter: {},
                isMyOffer: false
            }
        },
        created() {
            window.addEventListener('beforeunload', this.beforeUnload);
            window.addEventListener('unload', this.beforeUnload);
        },
        beforeDestroy() {
            window.removeEventListener('beforeunload', this.beforeUnload);
            window.addEventListener('unload', this.beforeUnload);
        },
        mounted() {
            this.getBuying();
        },
        computed: {
            prototypeGroups() {
                return _.uniq(_.map(this.buyingPresenter.goods, 'prototypeGroup'));
            },
            prototypeSubGroups() {
                return _.uniq(_.map(this.buyingPresenter.goods, 'prototypeSubGroup'));
            },
            excelLink() {
                return `/seller/buying/index?id=${this.buyingPresenter.id}&type=${this.buyingPresenter.type}&excel=on`;
            },
            emailLink() {
                return `/seller/buying/index?id=${this.buyingPresenter.id}&type=${this.buyingPresenter.type}&email=on`;
            }
        },
        sockets: {
            connect() {
                this.getBuying();
            },
            newPrice(data) {
                if (!this.isMyOffer) {
                    this.$notify({message: 'Цены изменились. Вы можете дать новое предложение.', type: 'success'});
                }
                this.getBuying();
                this.isMyOffer = false;
            }
        },
        methods: {
            beforeUnload() {
                this.$socket.disconnect();
            },
            getFormattedPrice(price) {
                return Intl.NumberFormat('ru-RU', {style: 'currency', currency: 'RUB'})
                    .format(price);
            },
            getNextPrice(price) {
                return price ? (price - price * this.buyingPresenter.normalizedStep).toFixed(2) : 0;
            },
            async getBuying() {
                let response = await BuyingService.getSellerBuying(this.id, this.type);
                if (response.success) {
                    this.buyingPresenter = response;
                }
            },
            setQuickPrice(price, item) {
                item.minOffer = price;
            },
            async makeOffer() {
                if(this.buyingPresenter.isDemoUser) {
                    this.$notify({message: 'Для подачи предложения необходимо зарегистрироваться на площадке!', type: 'error'});
                    this.openRegister();
                    return;
                }

                let offers = {};
                this.isMyOffer = true;
                this.buyingPresenter.goods.forEach((item) => {
                    offers[item.position.id] = item.minOffer;
                });
                let response = await BuyingService.makeOffer(
                    this.buyingPresenter.id,
                    this.buyingPresenter.type,
                    offers
                );

                if (response.success) {
                    this.$notify({message: response.message, type: 'success'});
                } else {
                    this.$notify({message: response.error.message, type: 'error'});
                }

                this.getBuying();
            },
            openRegister() {
                $('.signupSeller').click();
            }
        },
        watch: {
            buyingPresenter: {
                handler() {
                    if (this.buyingPresenter.id) {
                        this.$socket.emit('register-event', {
                            event: 'newPrice',
                            id: this.buyingPresenter.id
                        });
                    }
                }
            }
        }
    }
</script>

<style scoped>

</style>